<div #mainContentWrapper id="main-content" tabindex="-1">
    <ng-content></ng-content>
</div>
